import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Language, LocalStorageKey } from "../shared/enums";
import EnglishTranslation from "./en.json";
import MandarinTranslation from "./zh.json";
import MalayTranslation from "./my.json";

i18n.use(initReactI18next).init({
    defaultNS: "common",
    debug: false,
    resources: {
        [Language.ENGLISH]: { common: EnglishTranslation },
        [Language.CHINESE]: { common: MandarinTranslation },
        [Language.MELAYU]: { common: MalayTranslation },
    },
    lng: (!(typeof window === "undefined") ? localStorage.getItem(LocalStorageKey.LANGUAGE) : '') || Language.ENGLISH,
    fallbackLng: [Language.ENGLISH, Language.CHINESE],
    keySeparator: false,
    interpolation: {
        escapeValue: false
    }
});

export default i18n;
